// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.required:after {
    content: " *";
    color: red;
}

.well {
    border: solid 1px #d3d3d3;
    background-color: #f5f5f5;
    padding: 15px 20px;
    border-radius: 4px;
    margin-bottom: 15px;
}

.btn-toolbar {
    margin-top: 12px;
    padding-bottom: 5px;
    gap: 8px;
    display: flex;
}
`, "",{"version":3,"sources":["webpack://./src/app/reports/lc-surety-bond-pricing-analysis/lc-surety-bond-pricing-analysis.component.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,QAAQ;IACR,aAAa;AACjB","sourcesContent":[".required:after {\r\n    content: \" *\";\r\n    color: red;\r\n}\r\n\r\n.well {\r\n    border: solid 1px #d3d3d3;\r\n    background-color: #f5f5f5;\r\n    padding: 15px 20px;\r\n    border-radius: 4px;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.btn-toolbar {\r\n    margin-top: 12px;\r\n    padding-bottom: 5px;\r\n    gap: 8px;\r\n    display: flex;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
